'use client';

import { createContext, useState, useContext, useId, useMemo } from 'react';

type IsOpenedContextType = {
	isOpened: boolean;
	setIsOpened: React.Dispatch<React.SetStateAction<boolean>>;
	id: string;
};

const IsOpenedContext = createContext<IsOpenedContextType | undefined>(
	undefined,
);

export const IsOpenedProvider = ({
	children,
	defaultValue = false,
}: {
	children: React.ReactNode;
	defaultValue?: boolean;
}) => {
	const [isOpened, setIsOpened] = useState<boolean>(defaultValue);
	const id = useId();
	const contextValue = useMemo(
		() => ({ isOpened, setIsOpened, id }),
		[isOpened, setIsOpened, id],
	);

	return (
		<IsOpenedContext.Provider value={contextValue}>
			{children}
		</IsOpenedContext.Provider>
	);
};

export const useIsOpened = () => {
	const context = useContext(IsOpenedContext);
	if (context === undefined) {
		throw new Error('useIsOpened must be used within an IsOpenedProvider');
	}

	return context;
};
